module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_1.467ccabb.png";